import './styles/global.css';

import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import TechBand from './components/TechBand/TechBand';
import Solutions from './components/Solutions/Solutions';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

const App = () => (
  <>
    <Navbar />

    <main>
      <Hero />
      <TechBand />
      <About />
      <Solutions />
      <Contact />
    </main>

    <Footer />
  </>
);

export default App;
